import { UserRole } from 'types/user'

type NewFrontendRedirectInput = {
  userIsLoading: boolean
  role?: string | null
  uiVersion?: unknown
  lkAppUrl?: string
  currentOrigin: string
}

function appendNoticeMoved(raw: string): string {
  const hashIndex = raw.indexOf('#')
  const beforeHash = hashIndex === -1 ? raw : raw.slice(0, hashIndex)
  const hash = hashIndex === -1 ? '' : raw.slice(hashIndex)
  const queryIndex = beforeHash.indexOf('?')

  if (queryIndex === -1) {
    return `${beforeHash}?notice=moved${hash}`
  }

  const base = beforeHash.slice(0, queryIndex)
  const params = new URLSearchParams(beforeHash.slice(queryIndex + 1))
  params.set('notice', 'moved')
  return `${base}?${params.toString()}${hash}`
}

const NEW_CABINET_UI_VERSION = 'ui-2026'

/** Customer with features.uiVersion === "ui-2026" goes to the new LK. Everyone else stays. */
export function getNewFrontendRedirectUrl({ userIsLoading, role, uiVersion, lkAppUrl, currentOrigin }: NewFrontendRedirectInput): string | null {
  if (userIsLoading) return null
  if (role !== UserRole.CUSTOMER) return null
  if (uiVersion !== NEW_CABINET_UI_VERSION) return null

  const raw = (lkAppUrl || '').trim()
  if (!raw) return null

  let target: URL
  try {
    target = new URL(raw)
  } catch {
    return null
  }

  if (target.origin === currentOrigin) return null

  return appendNoticeMoved(raw)
}
